import React from 'react'

import * as THREE from 'three'
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls'

import collapsed from './../../../UI/general/collapse.svg'
import close from "./../../../UI/general/close.svg"
import next from "./../../../UI/general/Next-Asset.svg"

import gallery from "./../../../UI/Modal/gallery.svg"

interface Viewer360Three {
  mountRef: any,
}

interface Props {
  isViewer360: boolean,
  handleCloseGallery: any,
  colorsData: any,
  amenityData: any,
  galleryName: string,
  breadCrumbs: any,
  handleGetBreadCrumbSelected: any
  comesFromModalGallery: boolean
}

interface State {
    isTouchScreen: boolean,
    zoom: number,
    zoomValue: number,
    isCollapsed: boolean,
    currentImage: string,
    currentSelectedtourIndex: number,
    rerender: boolean,
    show: boolean,
    rgbaColor: any,
    currentHoverSelected: number
}
declare const window: any;


const scene = new THREE.Scene()
scene.background = new THREE.Color(0x000000)

class Viewer360Three extends React.Component<Props,State>{

  constructor(props: Props){
    super(props);
    this.state = {
      isTouchScreen: false,
      zoom: 80,
      zoomValue: 0,
      isCollapsed: !this.props.comesFromModalGallery,
      currentImage: "",
      currentSelectedtourIndex: 0,
      rerender: false,
      show: false,
      rgbaColor: {},
      currentHoverSelected: -1
    }

    this.mountRef = React.createRef()
  }

  componentDidMount(): void {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(this.props.colorsData.main_buttons)
    this.setState({
      rgbaColor: result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : ""
    })
    if(this.state.isCollapsed){
        setTimeout(() => {
            this.setState({
                isCollapsed: false
            })
        },500)
    }
    this.setState({
        show: true
    }, () => {
        this.handleMount()
    })
}

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    if(prevProps.isViewer360 !== this.props.isViewer360 && this.props.isViewer360){
        this.setState({
            isCollapsed: this.props.breadCrumbs.length === 0
        }, () => {
            if(this.state.isCollapsed){
                setTimeout(() => {
                    this.setState({
                        isCollapsed: false
                    })
                },500)
            }
        })
        
    }
}

handleMount =() => {
    const currentMount = this.mountRef.current

        const  camera = new THREE.PerspectiveCamera(75,currentMount.clientWidth / currentMount.clientHeight, 0.1, 1000)
        camera.position.set(1,1,1)
    
        //renderer set up
        const renderer = new THREE.WebGLRenderer({antialias: true})
        renderer.setSize(currentMount.clientWidth, currentMount.clientHeight)
        renderer.outputEncoding = THREE.sRGBEncoding;
        currentMount.appendChild(renderer.domElement)
    
        const controls = new OrbitControls(camera, renderer.domElement)
        controls.target = new THREE.Vector3(0,0,0)
        controls.enableDamping = true
        controls.rotateSpeed = -0.4
    
        scene.add(camera)
    
        //create texture for sphere

        THREE.TextureLoader.prototype.crossOrigin = "anonymous";
    
        const loader = new THREE.TextureLoader()
        loader.setCrossOrigin("")
        loader.crossOrigin = ''
        const texture = loader.load((window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") + (this.props.amenityData.links[0].link).replace(' ', '+'), (texture) => {
          texture.encoding = THREE.sRGBEncoding;
          texture.mapping = THREE.EquirectangularReflectionMapping;
        })
        texture.flipY = false
        texture.wrapS = THREE.RepeatWrapping;
        texture.repeat.x = - 1;
        texture.magFilter = THREE.NearestFilter
        
        const material = new THREE.MeshBasicMaterial({side: THREE.BackSide, combine: THREE.MultiplyOperation, envMap: texture})
    
        const geometry = new THREE.SphereGeometry( 32, 32, 32 );
        const sphere = new THREE.Mesh( geometry, material );
        sphere.name = 'viewer360'
        sphere.scale.set(1,1,1)
        scene.add( sphere );
    
    
        //Ambient Ligth
        const AO = new THREE.AmbientLight(0xffffff, 2)
        scene.add(AO)
    
        const animate = () => {
            requestAnimationFrame(animate)
            controls.update()
            renderer.render(scene, camera)
        }
    
        animate()

        const SceneContainer = new ResizeObserver((div) => {
            let rect = div[0].contentRect
            renderer.setSize(rect.width, rect.height)
        })

        const SceneContainerDiv = document.querySelector('#scene-container') as any

        SceneContainer.observe(SceneContainerDiv)
}

handleSelectRender = (payload: string) => {
    var selectedObject: any = scene.getObjectByName('viewer360')
    const loader = new THREE.TextureLoader()
        loader.setCrossOrigin("")
        loader.crossOrigin = ''
        const texture = loader.load((window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") + (payload).replace(' ', '+'), (texture) => {
          texture.encoding = THREE.sRGBEncoding;
          texture.mapping = THREE.EquirectangularReflectionMapping;
        })
        texture.flipY = false
        texture.wrapS = THREE.RepeatWrapping;
        texture.repeat.x = - 1;
        texture.magFilter = THREE.NearestFilter
        
    const material = new THREE.MeshBasicMaterial({side: THREE.BackSide, combine: THREE.MultiplyOperation, envMap: texture})
    selectedObject.material = material
    selectedObject.dipose()
}

handleRenderSize = () => {
}

render(): React.ReactNode {
    return(
        <div className={this.state.show ? 'viewer-360-container fade-in':'viewer-360-container fade-out'}>
                {
                    this.props.isViewer360 ?
                    <div className={this.state.isCollapsed ? "gallery-file-container-wide":"gallery-file-container"} >
                        <div ref={this.mountRef} className='scene-container' id='scene-container'>

                        </div>
                    </div>:null
                }
                <div 
                    className={this.state.isCollapsed ? 'sidebar-gallery-btn-collapsed':'sidebar-gallery-btn'}
                    onClick = {() => {
                        this.setState({
                            isCollapsed: !this.state.isCollapsed
                        })
                        this.handleRenderSize()
                    }}
                >
                    <img src={collapsed} alt=""/>
                </div>

                <div className={this.state.isCollapsed ? 'sidebar-gallery-container-collapsed':'sidebar-gallery-container'}>
                    <div 
                        className="general-gallery-close-container"
                        onClick={() => {
                            this.setState({
                                isCollapsed: true
                            })
                            setTimeout(() => {
                                this.props.handleCloseGallery()
                            }) 
                        }}
                    >
                        <img src={close} alt=''/>
                    </div>
                    {
                        this.props.galleryName !== '' && this.props.breadCrumbs.length === 0 ?
                        <div className='gallery-modal-name'
                        onClick={this.props.breadCrumbs.length > 0 ?
                            () => {
                                this.props.handleGetBreadCrumbSelected(-1)
                                this.setState({
                                    show: false
                                })
                            }:() => {}
                        }
                        style={{
                            cursor: this.props.breadCrumbs.length > 0 ? 'pointer':'inherit'
                        }}
                        >{this.props.breadCrumbs.length > 0 ? 'Galería':this.props.galleryName}</div>:null
                    }
                    {
                    this.props.galleryName !== '' && this.props.breadCrumbs.length > 0 ?
                    <React.Fragment>
                        <div className='general-gallery-img-icon-container'>
                            <img src={gallery} alt=''/>
                        </div>
                        <div className='galerry-name-desktop'>GALERÍA</div>
                    </React.Fragment>:null
                }
                    {
                    this.props.breadCrumbs.length > 0 ?
                    <div className='breadcrumbs-gallery-modal-container-desktop'>
                        <div className='breadcrumb' onClick={() => {
                            this.props.handleGetBreadCrumbSelected(-1)
                            this.setState({
                                show: false
                            })
                        }}>Galería</div>
                        {
                            this.props.breadCrumbs.map((breadCrumb :any, index: number) => 
                                <React.Fragment>
                                    <img src={next} alt=''/>
                                    <div 
                                    className={index === this.props.breadCrumbs.length - 1 ? 'last-breadcrumb':'breadcrumb'}
                                    onClick={index === this.props.breadCrumbs.length -1 ? () => {}:() => {
                                        this.props.handleGetBreadCrumbSelected(index)
                                        this.setState({
                                            show: false
                                        })
                                    }}
                                    style={{
                                        backgroundColor: index === this.props.breadCrumbs.length -1 ? this.props.colorsData.main_buttons:'#fff',
                                        animation: index === this.props.breadCrumbs.length -1 ? 'moveLeftAlt 0.4s ease-in-out 1':'none'
                                    }}
                                    >
                                        {breadCrumb}
                                    </div>
                                </React.Fragment>
                            )
                        }
                    </div>:null
                }
                    <div className='sidebar-gallery-preview-container' style={{top: this.props.breadCrumbs.length > 0 ? '23%':'10%', height: this.props.breadCrumbs.length > 0 ? '77%':'90%'}}>
                        {
                            this.props.amenityData && this.props.amenityData.links ?
                            this.props.amenityData.links.map((render: any, index: number) =>
                                <div className='individual-tour-container' 
                                onClick = {() => {
                                    this.setState({currentSelectedtourIndex: index})
                                    this.handleSelectRender(render.link)
                                }}
                                style={{
                                    animation: 'fadein ' + (index + 1) + 's ease-in-out 1'
                                }}
                                >
                                    <div 
                                        className='individual-tour-image-container'
                                        onMouseEnter={() => {
                                            this.setState({
                                                currentHoverSelected: index
                                            })
                                        }}
                                        onMouseLeave={() => {
                                            this.setState({
                                                currentHoverSelected: -1
                                            })
                                        }}
                                    >
                                        <img src={(window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") + render.link} alt=""></img>
                                        <div 
                                        className='hover-gallery' 
                                        style={{
                                            opacity: this.state.currentSelectedtourIndex === index || this.state.currentHoverSelected === index ? 1:0, 
                                            backgroundColor: this.state.currentSelectedtourIndex === index ? `rgba(${this.state.rgbaColor.r},${this.state.rgbaColor.g},${this.state.rgbaColor.b}, 0.8)`:this.state.currentHoverSelected === index ? 'rgba(250,250,250,0.56)':'none'
                                        }}/>
                                        <div className='gallery-name'>{render.name.slice(0,-5).replaceAll('_',' ')}</div>
                                    </div>
                                </div>
                            ):null
                        }
                    </div>
                </div>
            </div>
      )
  }
}

export default Viewer360Three